import { useEffect } from 'react';

const PID = 7851756;

function isEmployers() {
  return (
    typeof window !== 'undefined' &&
    window.location.pathname.startsWith('/employers')
  );
}
function isPreviewHost(host: string) {
  // any *.vercel.app is considered preview
  return /\.vercel\.app$/i.test(host);
}
function isLocalHost(host: string) {
  return (
    host === 'localhost' || host.startsWith('127.') || host.endsWith('.local')
  );
}
function isAllowedHost(host: string) {
  // allow only your real domains (dev & prod)
  return host === 'leafwell.com' || host === 'dev.leafwell.com';
}

function fireLinkedInPageViewOnce() {
  // avoid duplicates on SPA navigations
  if ((window as any).__li_pv_fired) return;
  (window as any).__li_pv_fired = true;

  const url = window.location.href;
  const time = Date.now();

  // 1) attribution_trigger
  new Image().src = `https://px.ads.linkedin.com/attribution_trigger?pid=${PID}&time=${time}&url=${encodeURIComponent(
    url,
  )}`;

  // 2) collect
  new Image().src = `https://px.ads.linkedin.com/collect?v=2&fmt=js&pid=${PID}&time=${time}&url=${encodeURIComponent(
    url,
  )}`;

  // 3) wa payload
  try {
    fetch('https://px.ads.linkedin.com/wa/?medium=fetch', {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        pids: [PID],
        scriptVersion: 255,
        time,
        domain: window.location.hostname,
        url,
        pageTitle: document.title,
        websiteSignalRequestId: self.crypto?.randomUUID?.() || String(time),
        isTranslated: false,
        liFatId: '',
        liGiant: '',
        misc: { psbState: -4 },
        isLinkedInApp: false,
        hem: null,
        signalType: 'PAGE_VISIT',
      }),
    });
  } catch {
    console.error('Error firing LinkedIn page view');
  }
}

export default function EmployersLinkedInPageviewEmulator() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const host = window.location.hostname;

    // only /employers + only dev/prod hosts; skip localhost and vercel preview
    if (
      !isEmployers() ||
      isLocalHost(host) ||
      isPreviewHost(host) ||
      !isAllowedHost(host)
    )
      return;

    // small microtask delay so title/url are ready
    setTimeout(fireLinkedInPageViewOnce, 0);
  }, []);

  return null;
}
